


export const Footer = () => {

    return (
        // <footer id="lcIdFooter" class="container-fluid lc-gutter">
        //     <div className="lc-footer-cont">
        //         <div class="d-lg-flex justify-conten-between bd-highlight mb-2 pt-5">
        //             <div class="lc-address col-md-12 col-lg-6 col-xl-5 pl-0 lc-footer-menu">

        //                 Санкт-Петербург, Потемкинская, д.4, лит. А<br />
        //                 <a href="tel:8 (812) 242 9999">8 (812) 242 9999</a>  /  <a href="https://leningradcenter.ru/contact">схема проезда</a> <span class="d-md-block d-lg-none"> / <a href="https://leningradcenter.ru/documents">Документы</a></span> <br />
        //                 Для заявлений на возврат <a href="mailto:reservation@leningradcenter.ru">reservation@leningradcenter.ru</a> <br />
        //                 Время работы кассы с 12:00 до 22:00
        //             </div>
        //             <div class="col-md-12 col-lg-6 col-xl-7 d-flex justify-content-center d-lg-block ">
        //                 <ul class="lc-soc-list float-lg-right mb-0 pl-0">
        //                     <li class="ml-lg-4"><a href="https://vk.com/leningradcenter"><span class="lc-ico icn-vk"></span></a></li>
        //                     <li class="ml-4"><a href="https://t.me/Leningrad_Center"><span class="lc-ico icn-telegram"></span></a></li>
        //                 </ul>
        //                 <div class="clearfix pb-lg-2"></div>
        //             </div>
        //         </div>
        //     </div>
        //     {/* <div class="lc-footer-cont">
        //         <div class="d-lg-flex justify-conten-between bd-highlight mb-2 pt-5">
        //             <div class="lc-address col-md-12 col-lg-6 col-xl-5 pl-0 lc-footer-menu">

        //                 Санкт-Петербург, Потемкинская, д.4, лит. А<br />
        //                     <a href="tel:8 (812) 242 9999">8 (812) 242 9999</a>  /  <a href="https://leningradcenter.ru/contact">схема проезда</a> <span class="d-md-block d-lg-none"> / <a href="https://leningradcenter.ru/documents">Документы</a></span> 
        //                     <br/>
        //                         Для заявлений на возврат <a href="mailto:reservation@leningradcenter.ru">reservation@leningradcenter.ru</a> <br>
        //                             Время работы кассы с 12:00 до 22:00
        //                         </div>
        //                         <div class="col-md-12 col-lg-6 col-xl-7 d-flex justify-content-center d-lg-block ">
        //                             <ul class="lc-soc-list float-lg-right mb-0 pl-0">
        //                                 <li class="ml-lg-4"><a href="https://vk.com/leningradcenter"><span class="lc-ico icn-vk"></span></a></li>
        //                                 <li class="ml-4"><a href="https://t.me/Leningrad_Center"><span class="lc-ico icn-telegram"></span></a></li>
        //                             </ul>
        //                             <div class="clearfix pb-lg-2"></div>
        //                         </div>
        //                     </div>

        //             <div class="row d-none d-lg-flex mt-5 lc-footer-menu">
        //                 <div class="col-2">
        //                     <a title="Афиша и билеты" href="https://leningradcenter.ru/afisha"><b>Афиша и билеты</b></a>
        //                     <ul>
        //                         <li><a title="Шоу" href="https://leningradcenter.ru/afisha/show">Шоу</a></li>
        //                         <li><a title=" Кино" href="https://leningradcenter.ru/afisha/cinema"> Кино</a></li>
        //                         <li><a title="Выставки" href="https://leningradcenter.ru/afisha/exhibition">Выставки</a></li>
        //                     </ul>
        //                 </div>
        //                 <div class="col-2">
        //                     <a title="О проекте" href="https://leningradcenter.ru/about-project"><b>О проекте</b></a>
        //                     <ul>
        //                         <li><a title="История создания" href="https://leningradcenter.ru/about-project/istoriya-sozdaniya">История создания</a></li>
        //                     </ul>
        //                 </div>
        //                 <div class="col-2">
        //                     <a title="Все документы" href="https://leningradcenter.ru/documents"><b>Все документы</b></a>
        //                 </div>
        //                 <div class="col-2">
        //                     <a title="Корпоративным клиентам" href="https://leningradcenter.ru/corporate"><b>Корпоративным клиентам</b></a>
        //                     <ul>
        //                         <li><a title="Проведение корпоративных мероприятий" href="https://leningradcenter.ru/corporate/arenda">Проведение корпоративных мероприятий</a></li>
        //                         <li><a title="Корпоративная покупка билетов" href="https://leningradcenter.ru/corporate">Корпоративная покупка билетов</a></li>
        //                     </ul>
        //                 </div>
        //             </div>

        //             <div id="idFooterCop" class="mt-lg-5 lc-copyright">
        //                 © Leningrad Centre Show Space 2014-@DateTime.Now.Year
        //             </div>
        //             <div class="clearfix pb-4"></div>
        //         </div>
        //     </div> */}
        // </footer>
        <footer>

        </footer>
    )


}